const { VITE_APP_CLOUDFRONT_URL, VITE_APP_STORAGE_BUCKET_URL } = import.meta.env;

export function getThumbnailLink({ link, size }: { link?: string; size?: number }) {
  if (!link) {
    return "";
  }

  if (URL.canParse(link)) {
    const url = new URL(link);
    if (url.hostname === "my.matterport.com") {
      const param = url.searchParams.get("m");

      if (param) {
        return `https://my.matterport.com/api/v1/player/models/${param}/thumb`;
      }
    }
    return link;
  }

  if (size) {
    return `${VITE_APP_CLOUDFRONT_URL}/${link}?width=${size}`;
  }

  return `${VITE_APP_STORAGE_BUCKET_URL}/${link}`;
}
